import {Col, Modal, Radio, Row, Tag} from 'antd';
import {useAppSelector} from '../../../common/hooks';
import CustomBar from './CustomBar';
import Map from './Map';
import {useState} from 'react';

////////// IMAGES
import socIcon from '../../../assets/soc.png';
import sohIcon from '../../../assets/soh.png';
import currentIcon from '../../../assets/current.png';
import cycleIcon from '../../../assets/cycle.png';
import fetIcon from '../../../assets/fet.png';
import packvoltIcon from '../../../assets/packvolt.png';
import statusIcon from '../../../assets/status.png';
///////// FAULT IMAGES
import allOkIcon from '../../../assets/fault_Icon/allOk.png';
import faultIcon from '../../../assets/fault_Icon/fault.png';
import battPrlIcon from '../../../assets/fault_Icon/battPrl.png';
import cellConnIcon from '../../../assets/fault_Icon/cellConn.png';
import cellDiffIcon from '../../../assets/fault_Icon/cellDiff.png';
import hardwareIcon from '../../../assets/fault_Icon/hardware.png';
import overCurrChgIcon from '../../../assets/fault_Icon/overCurrChg.png';
import overCurrDchgIcon from '../../../assets/fault_Icon/overCurrDchg.png';
import overCurrConIcon from '../../../assets/fault_Icon/overCurrCon.png';
import overTempIcon from '../../../assets/fault_Icon/overTemp.png';
import overTempBrdIcon from '../../../assets/fault_Icon/overTempBrd.png';
import overVoltIcon from '../../../assets/fault_Icon/overVoltage.png';
import packOverVoltIcon from '../../../assets/fault_Icon/packOverVol.png';
import shortCktIcon from '../../../assets/fault_Icon/shortCkt.png';
import thermalRunawayIcon from '../../../assets/fault_Icon/thermal.png';
import underTempIcon from '../../../assets/fault_Icon/underTemp.png';
import underTempBrdIcon from '../../../assets/fault_Icon/undertempborad.png';
import underVoltIcon from '../../../assets/fault_Icon/underVoltage.png';

const totalFaults = [
  {name: 'Battery Parallel', icon: battPrlIcon},
  {name: 'Cell Connection', icon: cellConnIcon},
  {name: 'Cell Difference', icon: cellDiffIcon},
  {name: 'Hardware Fault', icon: hardwareIcon},
  {name: 'Over Current Charge', icon: overCurrChgIcon},
  {name: 'Over Current Discharge', icon: overCurrDchgIcon},
  {name: 'Over Current Continuous', icon: overCurrConIcon},
  {name: 'Over Temperature', icon: overTempIcon},
  {name: 'Over Temperature Board', icon: overTempBrdIcon},
  {name: 'Over Voltage', icon: overVoltIcon},
  {name: 'Pack Over Voltage', icon: packOverVoltIcon},
  {name: 'Short Circuit', icon: shortCktIcon},
  {name: 'Thermal Runaway', icon: thermalRunawayIcon},
  {name: 'Under Temperature', icon: underTempIcon},
  {name: 'Under Temperature Board', icon: underTempBrdIcon},
  {name: 'Under Voltage', icon: underVoltIcon},
];

const Main = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const state = useAppSelector((state) => state.liveBatteries.batteryDetails);
  const [view, setView] = useState<'MAP' | 'DETAIL'>('DETAIL'); // default is 'middle'

  return (
    <Modal
      title={
        <div style={{display: 'flex', width: '90%', justifyContent: 'space-between'}}>
          <Radio.Group value={view} onChange={(e) => setView(e.target.value)}>
            <Radio.Button value='DETAIL'>Details</Radio.Button>
            <Radio.Button value='MAP'>Map</Radio.Button>
          </Radio.Group>
        </div>
      }
      maskClosable={false}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      style={{top: '20px'}}
      width={'80vw'}
      footer={null}
    >
      {view === 'DETAIL' ? (
        <>
          {Object.keys(state).length > 2 ? (
            <>
              <Row style={{marginBottom: '10px'}}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    fontWeight: 'bold',
                    paddingInline: '10px',
                    marginBottom: '10px',
                  }}
                >
                  <Tag color='grey' style={{fontSize: '16px'}}>
                    Bid : {state.asset_id}
                  </Tag>
                  <Tag color='grey' style={{fontSize: '16px'}}>
                    Mid : {state.mid}
                  </Tag>
                </div>
              </Row>
              <Row style={{marginBottom: '30px'}}>
                <div style={{display: 'flex', width: '100%', justifyContent: 'space-around'}}>
                  <DataBox
                    name='State of Charge'
                    value={`${state.soc} %`}
                    color={'#0d74e8'}
                    icon={socIcon}
                  />
                  <DataBox
                    name='State of Health'
                    value={`${state.soh} %`}
                    color={'#0d74e8'}
                    icon={sohIcon}
                  />
                  <DataBox
                    name='Cycles Count'
                    value={state.cycles}
                    color={'#0d74e8'}
                    icon={cycleIcon}
                  />
                  <DataBox
                    name='Pack Voltage'
                    value={`${state.pack_voltage / 1000} V`}
                    color={'#0d74e8'}
                    icon={packvoltIcon}
                  />
                  <DataBox
                    name='Current'
                    value={
                      state.current < 300 && state.current > -300
                        ? '0 Amp'
                        : `${state.current / 1000} Amp`
                    }
                    color={'#0d74e8'}
                    icon={currentIcon}
                  />
                  <DataBox
                    name='Status'
                    value={
                      state.current > 300
                        ? 'Charging'
                        : state.current < -300
                        ? 'Discharging'
                        : 'Idle'
                    }
                    color={
                      state.current > 300 ? '#32cd32' : state.current < -300 ? '#ff0000' : '#0d74e8'
                    }
                    icon={statusIcon}
                  />

                  <DataBox
                    name='User Chg Fet'
                    value={state.userCharging ? 'ON' : 'OFF'}
                    color={state.userCharging ? '#32cd32' : '#ff0000'}
                    icon={fetIcon}
                  />
                  <DataBox
                    name='Actual Chg Fet'
                    value={state.actualCharging ? 'ON' : 'OFF'}
                    color={state.actualCharging ? '#32cd32' : '#ff0000'}
                    icon={fetIcon}
                  />
                  <DataBox
                    name='User Dchg Fet'
                    value={state.userDischarging ? 'ON' : 'OFF'}
                    color={state.userDischarging ? '#32cd32' : '#ff0000'}
                    icon={fetIcon}
                  />

                  <DataBox
                    name='Actual Dchg Fet'
                    value={state.actualDischarging ? 'ON' : 'OFF'}
                    color={state.actualDischarging ? '#32cd32' : '#ff0000'}
                    icon={fetIcon}
                  />
                </div>
              </Row>
              <Row>
                <Col span={6}>
                  <div style={{height: '350px'}}>
                    <CustomBar temp={state.temp_sensor} />
                  </div>
                </Col>
                <Col span={17} offset={1}>
                  <div style={{height: '350px'}}>
                    {state && state && state.cell_volt && <CustomBar cellVolts={state.cell_volt} />}
                  </div>
                </Col>
              </Row>
              <Row>
                <FaultDiv fault={state.fault_status} />
              </Row>
            </>
          ) : (
            <h3 style={{padding: '50px', textAlign: 'center'}}>No data Available</h3>
          )}
        </>
      ) : (
        <Map
          lat={state.latitude}
          lng={state.longitude}
          bid={state.asset_id}
          soc={state.soc}
          soh={state.soh}
          mid={state.mid}
        />
      )}
    </Modal>
  );
};

const DataBox = ({
  name,
  value,
  color,
  icon,
}: {
  name: string;
  value: number | string;
  color: string;
  icon: string;
}) => {
  return (
    <div
      style={{
        minWidth: '9%',
        height: '150px',
        overflow: 'hidden',
        borderRadius: '5px',
        boxShadow: '2px 3px 17px 1px #888888',
      }}
    >
      <div
        style={{
          backgroundColor: `${color}`,
          height: '70%',
          paddingInline: '5px',
          paddingTop: '10px',
        }}
      >
        <div style={{textAlign: 'center'}}>
          <img src={icon} style={{width: '40px'}} />
        </div>
        <div style={{textAlign: 'center', padding: '3px', fontSize: '16px', color: '#FFF'}}>
          {name}
        </div>
      </div>
      <div style={{textAlign: 'center', padding: '3px', fontSize: '16px'}}>{value}</div>
    </div>
  );
};

const FaultDiv = ({fault}: {fault: string[]}) => {
  return (
    <div
      style={{
        width: '100%',
        height: '120px',
        backgroundColor: '#bdbdbd',
        display: 'flex',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: '100px',
          paddingInline: '5px',
          paddingBlock: '20px',
          backgroundColor: `${fault.length === 0 ? 'limegreen' : 'red'}`,
        }}
      >
        <div style={{textAlign: 'center', height: '50%'}}>
          <img src={fault.length === 0 ? allOkIcon : faultIcon} style={{width: '40px'}} />
        </div>
        <div style={{textAlign: 'center', padding: '3px', fontSize: '16px', color: '#FFF'}}>
          {fault.length === 0 ? 'All Ok' : 'Fault'}
        </div>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {totalFaults.map((x) => {
          const color = fault.includes(x.name) ? 'red' : 'transparent';
          return (
            <div
              key={x.name}
              style={{
                paddingInline: '5px',
                paddingTop: '10px',
                backgroundColor: `${color}`,
                height: '100%',
                width: '6%',
                borderRadius: '7px',
              }}
            >
              <div style={{textAlign: 'center', height: '40%'}}>
                <img src={x.icon} style={{width: '35px'}} />
              </div>
              <div style={{textAlign: 'center', padding: '3px', fontSize: '12px', color: '#FFF'}}>
                {x.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Main;
